import React from "react"
import {
  Heading, Select, Text, Box, Grid, GridItem, Stack,
  Flex,
} from "@chakra-ui/react"
import { range } from "lodash"
import FormSection from "pages/EventShow/Forms/FormManagement/FormSection"
import { Form } from "sharedTypes"
import InputWithLabel from "./InputWithLabel"
import FormHeader from "../FormHeader"

type Props = {
  label: string;
  form: Form
}

const FormPlusOnes = ({ label, form }: Props) => {
  const {
    maxPlusOnes,
    plusOnesEnabled,
    plusOneNameEnabled = true,
    plusOneEmailEnabled = true,
    plusOneEmailRequired = false,
    translations: {
      rsvpPlusOneYes,
      plusOnesHeader,
      firstName,
      lastName,
      emailAddress,
    },
  } = form

  const collectDetails = plusOneNameEnabled || plusOneEmailEnabled

  if (!plusOnesEnabled) {
    return null
  }

  return (
    <>
      <FormHeader icon="guest-group" isSeparate={false}>
        <Text fontSize="2xl" fontWeight="semibold">{plusOnesHeader}</Text>
      </FormHeader>
      <Box borderWidth={1}>
        <FormSection>
          <Stack spacing={8} px={6}>
            <Flex flexDirection="column" gap={4}>
              <Heading size="sm" fontWeight="semibold" color="gray.700">{label}</Heading>
              <Select
                value={String(maxPlusOnes)}
                w="max-content"
              >
                <option value={String(maxPlusOnes)}>
                  {`${rsvpPlusOneYes} (+${maxPlusOnes})`}
                </option>
              </Select>
            </Flex>
            {collectDetails && (
              <Grid
                templateColumns={plusOneGridTemplateColumns(
                  plusOneNameEnabled,
                  plusOneEmailEnabled,
                )}
                columnGap={3}
                rowGap={8}
              >
                {range(maxPlusOnes).map((i) => (
                  <React.Fragment key={i}>
                    <GridItem
                      display="flex"
                      justifyContent="left"
                      alignItems="flex-end"
                      mb={2}
                    >
                      <Text fontWeight="semibold" color="gray.700">#{i + 1}</Text>
                    </GridItem>
                    {plusOneNameEnabled && (
                      <>
                        <GridItem>
                          <InputWithLabel label={firstName} required />
                        </GridItem>
                        <GridItem>
                          <InputWithLabel label={lastName} required />
                        </GridItem>
                      </>
                    )}
                    {plusOneEmailEnabled && (
                      <GridItem>
                        <InputWithLabel label={emailAddress} required={plusOneEmailRequired} />
                      </GridItem>
                    )}
                  </React.Fragment>
                ))}
              </Grid>
            )}
          </Stack>
        </FormSection>
      </Box>
    </>
  )
}

const plusOneGridTemplateColumns = (
  plusOneNameEnabled: boolean,
  plusOneEmailEnabled: boolean,
) => {
  if (plusOneNameEnabled && plusOneEmailEnabled) {
    return "2rem minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)"
  }
  if (plusOneNameEnabled) {
    return "2rem minmax(0, 1fr) minmax(0, 1fr)"
  }
  return "2rem minmax(0, 1fr)"
}

export default FormPlusOnes
